import { render, staticRenderFns } from "./bookmarkScreen.vue?vue&type=template&id=5db5c5c8&scoped=true&"
import script from "./bookmarkScreen.vue?vue&type=script&lang=js&"
export * from "./bookmarkScreen.vue?vue&type=script&lang=js&"
import style0 from "./bookmarkScreen.vue?vue&type=style&index=0&id=5db5c5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5c5c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VRow})
